module.exports = __webpack_public_path__ + "static/shotlists_notes@2x-37bd42d2457b9d96ec7316faee78d8b3.png";